module.exports = __webpack_public_path__ + "img/W7007-thumb.a23e6f90.jpg";